export const decodeUriString = (uriString: string) => decodeURIComponent(uriString).replace(/\+/g, ' ');
